import { render } from "./ConfirmationDialogBox.vue?vue&type=template&id=c93c95cc&scoped=true"
import script from "./ConfirmationDialogBox.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogBox.vue?vue&type=script&lang=js"

import "./ConfirmationDialogBox.vue?vue&type=style&index=0&id=c93c95cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c93c95cc"]])

export default __exports__